window.slate = window.slate || {};
window.theme = window.theme || {};
window.Sugra = window.Sugra || {};
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    //console.log(selectors.productJson, this.$container, $(selectors.productJson, this.$container));
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $(selectors.priceWrapper, this.$container).addClass('price--on-sale');
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $(selectors.priceWrapper, this.$container).removeClass('price--on-sale');
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$elementToFocus.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {    
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
      
      //console.log('_onSelectChange');
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
    //console.log($('#RecoverPasswordForm'), $('#RecoverPasswordForm').attr('class'));
    //console.log($('#CustomerLoginForm'), $('#CustomerLoginForm').attr('class'));
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

this.Sugra = this.Sugra || {};
this.Sugra.About = (function($) {
    
    var currentClone;
    
	function initAbout() {
        if ($('.about-cloneable').length) {
            initCloning();
        }
	}
	
	function initCloning() {
	    $('.about-cloneable').on('mousedown', '.cloneable', function(e) {
	        var newElement = $(this).clone();
            var newElementX = $(this).offset().left;
            var newElementY = $(this).offset().top;
            newElement.attr('id', 'clone-' + (new Date()).getTime());
            newElement.css('left', newElementX);
            newElement.css('top', newElementY);
            newElement.css('width', $(this).width());
            newElement.css('height', $(this).height());
            newElement.css('opacity', 0.5);
            newElement.css('position', 'absolute');
            newElement.css('transform', 'translateX(-50%) translateY(-50%)');
            newElement.css('z-index', 2001);            
            
            $('body').append(newElement);
            currentClone = newElement;
            updateCopyPosition(e);
	    });
	    
	    $('body').on('mousemove', function(e) {	        
            updateCopyPosition(e);
	    });
	    
	    $('body').on('mouseup', function(e) {
	        if (currentClone !== null) {
                currentClone.css('pointer-events', 'none');
                currentClone.css('opacity', 1);
                currentClone = null;
	        }
	    });
	}
	
	function updateCopyPosition(e) {	        
        var mouseX = document.all ? window.event.clientX : e.pageX;
        var mouseY = document.all ? window.event.clientY : e.pageY;
        
        if (currentClone !== null) {
            $(currentClone).css('left', mouseX + 'px');
            $(currentClone).css('top', mouseY + 'px');
        }	
	}

	return {
		init: function() {
			initAbout();
		}
	};

})(jQuery);
	


this.Sugra = this.Sugra || {};
this.Sugra.Cart = (function($) {

    var addCartUrl = '/cart/add.js';
    var cartData = {};
    var cartUrl = '/cart.js';
    var cartChangeUrl = '/cart/change.js';
    var cartSelector = '#cart-panel';
    var cartItemTemplate = '#cart-panel-item';
    var formSelector = 'form[action^="/cart/add"]';
    var moneyFormat = '${{ amount }}';
    var updateCartUrl = '/cart/update.js';

	function initCart() {
	    $('nav .cart-link').on('click', function(e) {
	        e.preventDefault();
            
            getCart().then(function(data) {
                updateCart(data);                    
                showPanel();
            });
	    });
	     
        $('.cart-panel-close').on('click', function(e) {
            e.preventDefault();
            
            hidePanel();
        });
        
        $('.cart-panel').on('keydown', function(e) {
            var ESC_BUTTON = 27;
        
            if (e.which == ESC_BUTTON) {
                e.preventDefault();
                
                hidePanel();
            }
        });        
        
        $('.cart-panel').on('transitionend MSTransitionEnd webkitTransitionEnd oTransitionEnd', function() {
	        if ($(this).attr('aria-hidden') == 'true') {
	            $(this).addClass('hidden');
	        }
	    });
        
        $(document).on('click', '.cart-panel-item-remove', function(e) {
            e.preventDefault();
            
            removeCartItem($(this)).then(function() {
                getCart().then(function(data) {
                    updateCart(data);
                });
            });
        });
        
        $(formSelector).not('.product-form-customizer').on('submit', function(e) {
            e.preventDefault();
            
            var form = $(this);
            var formData = form.serialize();
            var formDataJson = form.serializeArray();
            //console.log(formDataJson);
            
            // Check for bundle and add to cart with bundle items array
            // @see https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
            var formBundle = checkBundle(formDataJson);            
            if (formBundle !== false) {
                formData = {
                    'items': formBundle
                };
            }
            
            form.find('[type="submit"]').prop('disabled', true);
        
            addToCart(formData).then(function() {
                getCart().then(function(data) {
                    updateCart(data);                    
                    showPanel();                    
                    
                    form.find('[type="submit"]').prop('disabled', false);
                });
            });            
        });
        
        $('#cart-panel-add-note').on('click', function(e) {        
            e.preventDefault();
            
            showOrderNote();
        });
        
        $('#cart-panel-note form').on('submit', function(e) {
            e.preventDefault();
            
            var form = $(this);
            var formData = form.serialize();
            
            form.find('[type="submit"]').prop('disabled', true);
            
            addOrderNote(formData).then(function() {
                getCart().then(function(data) {
                    updateCart(data);
                    hideOrderNote();                  
                    
                    form.find('[type="submit"]').prop('disabled', false);
                });
            });
        });
        
        $('#cart-panel-note').on('keydown', function(e) {
            var ESC_BUTTON = 27;
        
            if (e.which == ESC_BUTTON) {
                e.preventDefault();
                e.stopPropagation();
                
                hideOrderNote();
            }
        });
	}
	
    function addToCart(data) {   
        return $.ajax({
            url: addCartUrl,
            dataType: 'json',
            type: 'post',
            data: data
        });
    }
    
    function addToCartCustom(data) {   
        return $.ajax({
            url: addCartUrl,
            type: 'post',
            processData: false,
            contentType: false,
            dataType: 'json',     
            data: data
        });
    }
	
	function getCart() {
        return $.ajax({
            url: cartUrl,
            dataType: 'json',
            type: 'get'
        });
    }
    
    function updateCart(cart) {
        //console.log('updateCartItems', cart);
       
        var cartItems = $(cartSelector).find('.cart-panel-items');
        var itemTemplate = $(cartItemTemplate).html();
        //console.log(itemTemplate);
        
        // Clear current items
        cartItems.empty();
        
        // Display messaging if empty cart
        if (cart.item_count === 0) {
            cartItems.append('<p class="cart-panel-empty">There are no items in your cart.</p>'); 
            $(cartSelector).find('.cart-panel-footer').hide();
            //return false;
        }
        
        // Add cart items to panel
        $.each(cart.items, function(index, cartItem) {
            var itemImage, itemImageAlt, itemName, itemPrice, itemHtml;
            
            // TODO: Add fallback for no image
            itemImage = '';
            itemImageAlt = cartItem.product_title;
        
            // Cart item image
            if (cartItem.featured_image != null) {
                itemImage = cartItem.featured_image.url;
                if (itemImage) {
                    itemImage = itemImage.replace(/\.(gif|jpg|jpeg|png)/gi, '_240x.$1');
                    itemImageAlt = cartItem.featured_image.alt;
                }
            }
            
            // Cart item name
            itemName = cartItem.product_title;
            
            // Cart item price
            itemPrice = formatMoney(cartItem.final_line_price, moneyFormat);
            
            // Cart item key
            itemKey = cartItem.key;
            
            // Cart item quantity
            itemQuantity = cartItem.quantity;
            
            // Prepare cart item HTML            
            itemHtml = itemTemplate;
            itemHtml = itemHtml.replace(/\[item-line\]/g, index + 1);
            itemHtml = itemHtml.replace(/\[item-image\]/g, itemImage);
            itemHtml = itemHtml.replace(/\[item-image-alt\]/g, itemImageAlt);
            itemHtml = itemHtml.replace(/\[item-name\]/g, itemName);
            itemHtml = itemHtml.replace(/\[item-price\]/g, itemPrice);
            itemHtml = itemHtml.replace(/\[item-key\]/g, itemKey);
            itemHtml = itemHtml.replace(/\[item-quantity\]/g, itemQuantity);
            itemHtml = itemHtml.replace(/\[item-options\]/g, getItemOptions(cartItem));
            itemHtml = itemHtml.replace(/\[item-properties\]/g, getItemProperties(cartItem));
            itemHtml = itemHtml.replace(/\[item-selling-plan\]/g, getItemSellingPlan(cartItem));
            
            //console.log(itemImage, itemImageAlt, itemName, itemPrice);
            //console.log('Appending', itemHtml);
            
            // Add cart item HTML to panel
            cartItems.append(itemHtml);    
        });
        
        // Update cart items subtotal
        $('.cart-panel-footer .totals-value').text(formatMoney(cart.items_subtotal_price, moneyFormat));
        $(cartSelector).find('.cart-panel-footer').show();
        
        // Update cart note button text
        if (cart.note === null) {
            $('#cart-panel-add-note').text('Add order note');
            $('#cart-panel-order-note').val('');
        } else {
            $('#cart-panel-add-note').text('Edit order note');
        
            $('#cart-panel-order-note').val(cart.note);            
        }
                
        // Update cart items header
        if (cart.item_count > 0) {
            $('nav .cart-number').text(cart.item_count);
        } else {
            $('nav .cart-number').text('');
        }
        
        // Update cart status
        if (cart.item_count > 0) {
            var itemsLabel = (cart.item_count == 1) ? 'item' : 'items';
            $('.cart-status').text(cart.item_count + ' ' + itemsLabel + ' in cart');
        } else {
            $('.cart-status').text('Cart empty');
        }        
    }
    
    function getItemOptions(item) {
        //console.log('Cart getItemOptions', typeof item.variant_title, item.variant_title);
        /*
        if (typeof item.options_with_values == 'object') {
            var options = '';
            item.options_with_values.forEach(function(option) {
                var optionItem = '';
                
                if (option.value != 'Default Title') {                    
                    optionItem += '<li>';
                    optionItem += option.name;
                    optionItem += ': ' + option.value;
                    optionItem += '</li>';                    
                }
                
                if (optionItem != '') {
                    options += optionItem;
                }
            });
                
            return options;            
        }
        */    
    
        if (item.variant_title) {
            return item.variant_title;
        }
        
        return '';
    }
    
    function getItemProperties(item) {
        //console.log('Cart getItemProperties', typeof item.properties, item.properties);
        
        if (typeof item.properties == 'object') {
            var properties = '';
            
            for (var property in item.properties) {                   
                var propertyItem = '';
                propertyItem += '<li>';
                propertyItem += property;
                if (item.properties[property] != '') {
                    propertyItem += ': ' + item.properties[property];                    
                }
                propertyItem += '</li>';  
                
                if (propertyItem != '') {
                    properties += propertyItem;
                }                                                
            }
            
            return properties;
        }
        
        return '';
    }
    
    function getItemSellingPlan(item) {
        //console.log('Cart getItemSellingPlan', typeof item.selling_plan_allocation, item.selling_plan_allocation);
    
        if (typeof item.selling_plan_allocation !== 'undefined') {
            return item.selling_plan_allocation.selling_plan.name;
        }
        
        return '';
    }        
        
    function changeCartItem(line, quantity) {
        /*       
        console.log({
            line: line,
            quantity: quantity
        });
        */
    
        return $.ajax({
            url: cartChangeUrl,
            dataType: 'json',
            type: 'get',
            data: {
                line: line,
                quantity: quantity
            }
        });
    }
    
    function removeCartItem(target) {
        var line = target.closest('.cart-panel-item').data('line');
        //console.log('removeCartItem', target, line);
        if (typeof line !== 'undefined') {    
            return changeCartItem(line, 0);
        }
    }
    
    function checkBundle(formData) {
        var bundle = false;
        var bundleItem = null;
        var mainItem = null;
        var mainQuantity = null;
        
        formData.forEach(function(element, index) {
            if (element.name == 'bundle') {
                bundleItem = element.value;
            }
            if (element.name == 'id') {
                mainItem = element.value;
            }
            if (element.name == 'quantity') {
                mainQuantity = element.value;
            }
        });
        
        //console.log(bundleItem, mainItem, mainQuantity);
        //console.log('bundleItem', bundleItem, bundleItem !== null);
        
        if (bundleItem !== null) {
            bundle = [];
        
            bundle.push({
                'id': bundleItem,
                'quantity': 1
            });        
        
            bundle.push({
                'id': mainItem,
                'quantity': Number(mainQuantity)
            });
        }
        
        //console.log('checkBundle', bundle);
        
        return bundle;
    }  
    
    // Standalone Shopify.formatMoney
    // @see https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
    formatMoney = function(cents, format) {
        if (typeof cents == 'string') {
            cents = cents.replace('.','');
        }
        
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || '${{ amount }}');

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal   = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) { return 0; }

            number = (number/100.0).toFixed(precision);

            var parts   = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents   = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch(formatString.match(placeholderRegex)[1]) {
            case 'amount':
              value = formatWithDelimiters(cents, 2);
              break;
            case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
            case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
              break;
            case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
        }

        return formatString.replace(placeholderRegex, value);
    };
    
    function showPanel() {
        $('.cart-panel').removeClass('hidden')            
            .attr('aria-hidden', 'false');
            
        window.setTimeout(function() {
            $('.cart-panel').addClass('active');
        }, 1);
        
        $('nav .cart-link a').attr('aria-expanded', 'true');
        
        slate.a11y.trapFocus({
            $container: $('.cart-panel'),
            $elementToFocus: $('.cart-panel-close'),
            namespace: 'cart'
        });        
        
        $('.cart-panel-overlay').show();
        
        $(document).on('click', cartPanelClick);
    }
    
    function hidePanel() {
       $('.cart-panel').removeClass('active note-active')
            .attr('aria-hidden', 'true');
            
        slate.a11y.removeTrapFocus({
            $container: $('.cart-panel'),
            namespace: 'cart'        
        });
        
        $('nav .cart-link a').attr('aria-expanded', 'false')
            .focus();
            
        $('.cart-panel-overlay').hide();
            
        $(document).off('click', cartPanelClick);
    }  
    
    function cartPanelClick(event) {	    
	    var targetCartLink = $(event.target).closest('.cart-link');
	    var targetCartPanel = $(event.target).closest('.cart-panel');
	    
	    //console.log('cartPanelClick', ! targetCartLink.length && ! targetCartPanel.length);
	    
	    // Close cart panel if click target wasn't inside cart link or panel
        if (  ! targetCartLink.length && ! targetCartPanel.length) {
            hidePanel();
        }
	}
    
    function addOrderNote(data) {
        return $.ajax({
            url: updateCartUrl,
            dataType: 'json',
            type: 'post',
            data: data
        });
    }
    
    function showOrderNote(e) {
        $(cartSelector).addClass('note-active');
        
        $('#cart-panel-add-note').attr('aria-expanded', 'true');
    
        $('#cart-panel-note').attr('aria-hidden', 'false');
        
        $('#cart-panel-order-note').focus();
    }
    
    function hideOrderNote() {
        $(cartSelector).removeClass('note-active');
    
        $('#cart-panel-add-note').attr('aria-expanded', 'false');
    
        $('#cart-panel-note').attr('aria-hidden', 'true');
        
        $('#cart-panel-add-note').focus();
    }    

	return {
		init: function() {
			initCart();
		},
		addToCart: function(data) {
		    return addToCart(data);
		},
		addToCartCustom: function(data) {
		    return addToCartCustom(data);
		},
		getCart: function() {
		    return getCart();
		},
		updateCart: function(data) {
		    updateCart(data)
		},
		showPanel: function() {
		    showPanel();
		},
		hidePanel: function() {
		    hidePanel();
		}
	};

})(jQuery);
	
this.Sugra = this.Sugra || {};
this.Sugra.Collections = (function($) {

	function initCollections() {
	    if ($('.collections-features').length > 0) {
            initFeatures();
        }
	
	    if ($('.collections-gallery').length > 0) {
            initGallery();
        }
	}	
	
	function initFeatures() {
	    fitty('.collections-feature h2');
	}
	
	function initGallery() {	    
        var slickSettings = {
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: 0
        };        
        
        var pagesTemplate = $.parseJSON($('#collections-pages-template').text());
        //console.log(pagesTemplate);
        
        $('.collections-gallery').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
            var currentPage = (currentSlide ? currentSlide : 0) + 1;
            
            var pages = pagesTemplate.replace('[currentPage]', currentPage)
                .replace('[totalPages]', slick.slideCount);
            
            $('#collections-pages').html(pages);
        });
        
        $('.collections-gallery').slick(slickSettings);
	}

	return {
		init: function() {
			initCollections();
		}
	};

})(jQuery);
	
this.Sugra = this.Sugra || {};
this.Sugra.Customer = (function($) {

	function initCustomer() {
		checkUrlHash();
		customerAddressForm();
		initEventListeners();
		resetPasswordSuccess();
	}

	function initEventListeners() {
		// Show reset password form
		$('#RecoverPassword').on('click', function(e) {
			e.preventDefault();
			toggleRecoverPasswordForm();
		});

		// Hide reset password form
		$('#HideRecoverPasswordLink').on('click', function(e) {
			e.preventDefault();
			toggleRecoverPasswordForm();
		});
	}

	/**
	*
	*  Show/Hide recover password form
	*
	*/
	function toggleRecoverPasswordForm() {
		$('#RecoverPasswordForm').toggleClass('hide');
		$('#CustomerLoginForm').toggleClass('hide');
	}

	/**
	*
	*  Show reset password success message
	*
	*/
	function resetPasswordSuccess() {
		var $formState = $('.reset-password-success');

		// check if reset password form was successfully submited.
		if ( ! $formState.length) {
			return;
		}

		// show success message
		$('#ResetSuccess').removeClass('hide');
	}

	/**
	*
	*  Show/hide customer address forms
	*
	*/
	function customerAddressForm() {
		var $newAddressForm = $('#AddressNewForm');

		if ( ! $newAddressForm.length) {
			return;
		}

		// Initialize observers on address selectors, defined in shopify_common.js
		if (Shopify) {
			// eslint-disable-next-line no-new
			new Shopify.CountryProvinceSelector(
				'AddressCountryNew',
				'AddressProvinceNew',
				{
					hideElement: 'AddressProvinceContainerNew'
				}
			);
		}

		// Initialize each edit form's country/province selector
		$('.address-country-option').each(function() {
			var formId = $(this).data('form-id');
			var countrySelector = 'AddressCountry_' + formId;
			var provinceSelector = 'AddressProvince_' + formId;
			var containerSelector = 'AddressProvinceContainer_' + formId;

			// eslint-disable-next-line no-new
			new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
				hideElement: containerSelector
			});
		});

		// Toggle new/edit address forms
		$('.address-new-toggle').on('click', function(e) {
		    e.preventDefault();
			
			$newAddressForm.toggleClass('hide');
		});

		$('.address-edit-toggle').on('click', function(e) {
		    e.preventDefault();
		    
			var formId = $(this).data('form-id');
			$('#EditAddress_' + formId).toggleClass('hide');
		});

		$('.address-delete').on('click', function(e) {
		    e.preventDefault();
		
			var $el = $(this);
			var formId = $el.data('form-id');
			var confirmMessage = $el.data('confirm-message');

			// eslint-disable-next-line no-alert
			if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
				Shopify.postLink('/account/addresses/' + formId, {parameters: { _method: 'delete' }});
			}
		});
	}

	/**
	*
	*  Check URL for reset password hash
	*
	*/
	function checkUrlHash() {
		var hash = window.location.hash;

		// Allow deep linking to recover password form
		if (hash === '#recover') {
			toggleRecoverPasswordForm();
		}
	}

	return {
		init: function() {
			initCustomer();
		}
	};

})(jQuery);
this.Sugra = this.Sugra || {};
this.Sugra.Customizer = (function($) {
    
    var addCartUrl = '/cart/add.js';
    var data = {};
    var debug = false;    
    var moneyFormat = '${{ amount }}';
    var stepIndex = 0;
    var stepTotal = 0;
    var viewModel = {}; // Knockout view model

	function initCustomizer() {
	    if ($('.customizer').length > 0) {
            $('.product-customizer').on('click', function(e) {
                e.preventDefault();
            
                showCustomizer();
            });
            
            $('#customizer').on('keydown', function(e) {
                var ESC_BUTTON = 27;
        
                if (e.which == ESC_BUTTON) {
                    hideCustomizer();
                }
            });
         
            $('#customizer-close').on('click', function(e) {
                e.preventDefault();
            
                hideCustomizer();
            });
        
            $('#customizer-button-next').on('click', function(e) {
                e.preventDefault();
            
                nextStep();
            });
        
            $('#customizer-button-previous').on('click', function(e) {
                e.preventDefault();
            
                prevStep();
            });
        
            $('#customizer-button-cart').on('click', function(e) {
                e.preventDefault();
            
                addToCart();
            });
            
            $(document).on('change', '.size-select select', function() {            
                updateImageSize();
            });
            
            $(window).on('resize', function() {          
                updateImageSize();
            });
        
            $(document).on('click', '.color-swatch', function(e) {
                e.preventDefault();
            
                viewModel.pickerSwatch($(this).data('label'));
                showPicker();
                updateSwatchState($(this).data('label'));
            });
            
            $(document).on('click', '.customizer-colors-reset', function(e) {
                e.preventDefault();
                
                resetColors();
            });
        
            $(document).on('click', '.picker-color', function(e) {
                e.preventDefault();
            
                if (viewModel.currentStep.slug() == 'step-3') {            
                    updateSwatch(viewModel.pickerSwatch(), $(this).data('color'));
                    updateImage(viewModel.pickerSwatch(), $(this).data('color'));
                    updateSwatchState(false);
                    
                    // Only hide picker on click for table/mobile
                    if ( ! window.matchMedia('(min-width: 992px)').matches) {
                        hidePicker();
                    }
                }
            });
            
            $(document).on('mouseenter', '.picker-color', function(e) { 
                e.preventDefault();
                
                //console.log('Current Color: ' + $(this).data('name'));                
                viewModel.pickerColor('Current Color: ' + $(this).data('name'));
            });
            
            $(document).on('mouseleave', '.picker-colors', function(e) { 
                e.preventDefault();
                
                //console.log('Choose a new color below');
                viewModel.pickerColor('Choose a new color below');
            }); 
        
            $('#customizer-image').on('click', 'rect, path', function(e) {
                e.preventDefault();
                
                // Prevent image click events from firing the 
                // pickClicker handler and closing picker
                e.stopPropagation();
            
                if (viewModel.currentStep.slug() == 'step-3') {
                    var areaId = $(this).attr('id')
                        .substring(0,3)
                        .replace('_', '');
                
                    viewModel.pickerSwatch(areaId);
                    showPicker();
                    updateSwatchState(areaId);
                }
            });
        
            $('.picker-close').on('click', function(e) {
                e.preventDefault();
            
                if (viewModel.currentStep.slug() == 'step-3') {
                    hidePicker();
                }
            });
        
            $('#customizer-download').on('click', function(e) {
                e.preventDefault();
            
                downloadImage();
            });
        
            initSVG();
        
            initViewModel();
        }
	}
	
    function showCustomizer() {
        $('body').addClass('customizer-active');
        
        $('.customizer').addClass('active')
            .attr('aria-hidden', 'false');
            
        slate.a11y.trapFocus({
            $container: $('#customizer'),
            $elementToFocus: $('#customizer-button-next'),
            namespace: 'customizer'
        });
    }
    
    function hideCustomizer() {
        $('body').removeClass('customizer-active');
        
        $('.customizer').removeClass('active')
            .attr('aria-hidden', 'true');
            
        slate.a11y.removeTrapFocus({
            $container: $('#customizer'),
            namespace: 'customizer'
        });
            
        $('.product-customizer').focus();
    }
    
    function resetCustomizer() {
        viewModel.currentSize = ko.observable('');
	    //viewModel.currentShipping = ko.observable(data.product.defaultShipping);
	    viewModel.pickerSwatch = ko.observable('');
	    viewModel.pickerColor = ko.observable('Choose a new color below');
	    changeStep(0);
	    resetColors();
    }
    
    function resetColors() {
        data.product.swatches.forEach(function(element, index) {
	        updateImage(element.label, element.color);
	        updateSwatch(element.label, element.color);
	    });
    }
    
    function showPicker() {
        $('.customizer').addClass('picker-active');
        $('#customizer-color-picker').attr('aria-hidden', 'false');
        viewModel.showPicker(true);
        $(document).on('click', pickerClick);
    }
    
    function hidePicker() {
        $('.customizer').removeClass('picker-active');
        $('#customizer-color-picker').attr('aria-hidden', 'true');
        viewModel.showPicker(false);
        $(document).off('click', pickerClick);
    }
    
    function pickerClick(event) {
	    var targetPicker = $(event.target).closest('#customizer-color-picker');
	    
	    // Close picker if click target wasn't inside picker container
        if (  ! targetPicker.length) {
            hidePicker();
        }
	}    
    
    function initSVG() {
        /*
        // Alternate method with URL encoding
        // Decode SVG code encode by Liquid url_encode filter
        // @link https://shopify.dev/docs/themes/liquid/reference/filters/string-filters#url_encode
        //var svgDecoded = decodeURIComponent(customizerSVGEncoded).replace(/\+/g, ' ');
        */
        
        // Get customizer SVG JSON converted by the Liquid json filter
        // @link https://shopify.dev/docs/themes/liquid/reference/filters/additional-filters#json
        var svgDecoded = '';
        if (typeof customizerSVG === 'string') {
            var svgDecoded = customizerSVG;
        }
        
        // Run through jQuery parseHTML to strip anything unnecessary
        // @link https://api.jquery.com/jQuery.parseHTML/
        var svgParsed = jQuery.parseHTML(svgDecoded);
        
        // Append parsed SVG code
        $('#customizer-image').append($(svgParsed));
        
        // Add preserveAspectRatio to SVG
	    // Attribute required for resizing and is not added by Illustrator	    
	    $('#customizer-image svg').attr('preserveAspectRatio', 'none'); 
    }      
	
	function initViewModel() {
	    // Get JSON from product page
	    data = JSON.parse($('#customizer-data').html());
	    //console.log('data', data);
	    
	    productData = JSON.parse($('[data-product-json]').html());
	    //console.log('productData', productData);
	    
	    // Set defaults for various properties
	    viewModel.showNext = ko.observable(false);
	    viewModel.showPrev = ko.observable(false);	    
	    viewModel.showCart = ko.observable(false);
	    viewModel.showPicker = ko.observable(false);
	    viewModel.showDownload = ko.observable(false);
	    viewModel.pickerSwatch = ko.observable('');
	    viewModel.pickerColor = ko.observable('Choose a new color below');
	    viewModel.pickerColor.subscribe(function(newValue) {
	        if (newValue) {
	            $('.picker-header p').stop(true, true)
	                .fadeTo(0, 0)
	                .fadeTo(200, 1);
	        }
	    });
	    viewModel.product = {
	        name: data.product.name,
	        image: data.product.image
	    };	    
	    viewModel.currentSize = ko.observable('');
	    //viewModel.currentShipping = ko.observable(data.product.defaultShipping);
	    viewModel.currentPrice = ko.pureComputed(function() {
	        //console.log('Updating price');
	        //return getPrice(viewModel.currentSize(), viewModel.currentShipping());
	        return getPrice(viewModel.currentSize());
	    }, viewModel);
	    viewModel.currentStep = {
	        slug: ko.observable(),
	        title: ko.observable(),
	        view: ko.observable(),
	        note: ko.observable(false),
	        info: ko.observable(false)
	    };
	    viewModel.currentMessage = ko.observable('');
	    
	    // Setup sizes
	    viewModel.sizes = ko.observableArray(getSizes());
	    
	    // Setup swatches
	    viewModel.colors = ko.observableArray(getColors());
	    
	    // Setup swatches
	    viewModel.swatches = ko.observableArray(getSwatches());
	    
	    // Setup shipping
	    //viewModel.shipping = ko.observableArray(getShipping());	    
        
        // Set step total from JSON	    
	    stepTotal = data.steps.length;
	    
	    // Set current step to first step
	    changeStep(0);
	    
        // Init Knockout
        ko.applyBindings(viewModel);	    
	}
	
	function getSizes() {
	    var sizes = [];
	    var sizeIndex = null;
	    
	    productData.options.forEach(function(element, index) {
	        if (element == 'Size') {
	            sizeIndex = index;
	        }
	    });
	    
	    productData.variants.forEach(function(variant) {
            variant.options.forEach(function(option, index) {
                if (index == sizeIndex && sizes.indexOf(option) === -1) {
                    sizes.push(option);
                }
            });
	    });
	    
	    return sizes;
	}
	
	function getColors() {
	    var colors = [];
	    
	    for (var i = 0; i < data.colorNames.length; i++) {
	        colors.push({
	           'label': data.colorNames[i],
	           'color': data.colorColors[i]
	        });
	    }
	    
	    // Update customizer data due to how we're 
	    // passing the values from Airfields
	    data.colors = colors;
	    	    
	    return data.colors;
	}
	
	function getSwatches() {
	    var swatches = [];
	    
	    for (var i = 0; i < data.product.swatchNames.length; i++) {
	        // Update product data due to how we're 
	        // passing the values from Airfields
	        data.product.swatches.push({
	           'label': data.product.swatchNames[i],
	           'color': data.product.swatchColors[i],
	           'customColor': ''
	        });
	        
	        swatches.push({
	           'label': data.product.swatchNames[i],
	           'color': ko.observable(data.product.swatchColors[i]),
	           'customColor': ko.observable('')
	        });
	    }
	
	    return swatches;
	}
	
	function getPrice(size) {
	    var sizeIndex = null;
	    var sizeOption = null;
	    var shippingIndex = null;
	    var shippingOption = null;
	    var price = 'Select a size for pricing';
	
	    productData.options.forEach(function(element, index) {
	        if (element == 'Size') {
	            sizeIndex = index;
	            sizeOption = 'option' + (index + 1);
	        }
	    });
        
        productData.variants.forEach(function(variant) {
            //console.log(size, variant[sizeOption]);
            if (variant[sizeOption] == size) {
                //console.log('Match', variant.price);
                price = formatMoney(variant.price, moneyFormat);
            }
        });
        
        return price;
	}
	
	function getVariantId(size) {
	    var sizeIndex = null;
	    var sizeOption = null;
	    var shippingIndex = null;
	    var shippingOption = null;
	    var id = null;
	
	    productData.options.forEach(function(element, index) {
	        if (element == 'Size') {
	            sizeIndex = index;
	            sizeOption = 'option' + (index + 1);
	        }
	    });
        
        productData.variants.forEach(function(variant) {
            //console.log(size, variant[sizeOption]);
            if (variant[sizeOption] == size) {
                //console.log('Match', variant.id);
                id = variant.id
            }
        });
        
        return id;
	}
	
	function nextStep() {
	    if (validateStep()) {
            var nextStep = stepIndex + 1;
            if (nextStep < stepTotal) {	    
                changeStep(nextStep);
            }
	    }
	}
	
	function prevStep() {
        var prevStep = stepIndex - 1;
        if (prevStep >= 0) {
            changeStep(prevStep);
        }
	}
	
	function validateStep() {
	    //console.log('Validate', data.steps[stepIndex].validate);
	    if (data.steps[stepIndex].validate) {
	        if (typeof viewModel[data.steps[stepIndex].validate]() === 'undefined') {
	            viewModel.currentMessage(data.steps[stepIndex].validateMessage);
	        
	            return false;
	        }
	    }
	    
	    viewModel.currentMessage('');
	    return true;
	}
	
	function changeStep(newStep) {	 
	    stepIndex = newStep; 
	   
	    viewModel.currentStep.slug(data.steps[stepIndex].slug);
	    viewModel.currentStep.title(data.steps[stepIndex].title);
	    viewModel.currentStep.view(data.steps[stepIndex].view);
	    viewModel.currentStep.note(data.steps[stepIndex].note);
	    viewModel.currentStep.info(data.steps[stepIndex].info);
	    
	    viewModel.currentMessage('');
	    
	    viewModel.showDownload(false);
	    if (data.steps[stepIndex].download) {
	        viewModel.showDownload(true);
	    }
	    
	    viewModel.showNext(false);
	    if (stepIndex < (stepTotal - 1)) {
	        viewModel.showNext(true);
	        viewModel.showCart(false);
	    }
	    
	    viewModel.showPrev(false);
	    if (stepIndex > 0) {
	        viewModel.showPrev(true);
	    }
	    
	    if (stepIndex == stepTotal - 1) {
	        viewModel.showCart(true);
	    }
	    
	    // Set active state to first swatch on color step
	    // Used as a visual indicator of relationship between swatches and rug
	    if (newStep == 2) {
	        if (data.product.swatches.length > 0) {
	            updateSwatchState(data.product.swatches[0].label);
	        }
	    } else {
	        updateSwatchState(false);
	    }
	    
	    //console.log('showNext', viewModel.showNext);
	    //console.log('showPrev', viewModel.showPrev);
	}
	
    function updateSwatch(swatch, color) {
        var currentSwatch = {};
        var currentSwatches = viewModel.swatches();        
        var updatedSwatch = {};
        
        currentSwatches.forEach(function(element, index) {
            if (element.label == swatch) {
                currentSwatch = element;
            }
        });
        
        //console.log('currentSwatch', currentSwatch);
        
        updatedSwatch = currentSwatch;
        updatedSwatch.customColor(color);
        
        //console.log('updatedSwatch', updatedSwatch);
        
        viewModel.swatches.replace(currentSwatch, updatedSwatch);
        
        //console.log(viewModel.swatches());
    }
    
    function updateSwatchState(swatch) {        
        // Update swatch
        $('.customizer-colors .swatch').removeClass('selected');
        
        $('.customizer-colors').find("[data-label='" + swatch + "'] .swatch")
            .addClass('selected');
        
        // Update swatch area(s) in image        
        $('#customizer-image').find('rect, path')
            .removeClass('selected');

        $('#customizer-image').find("[id='" + swatch + "'], [id^='" + swatch + "_']")
            .addClass('selected');
    }
    
    function updateImage(swatch, color) {
        //console.log("[id='" + swatch + "'], [id^='" + swatch + "_']", color);
        
        $('#customizer-image').find("[id='" + swatch + "'], [id^='" + swatch + "_']")
            .css({ fill: color });
    }
    
    function updateImageSize() {
        if (typeof viewModel.currentSize === 'undefined' || ! viewModel.currentSize()) {
            return false;
        }
        
        // Get width and height from selected size
        var value = viewModel.currentSize();        
        value = value.replace(/([^0-9x])/gi, '');
        var dimensions = value.split('x');   
        
        // Width and height are reversed since rug is displayed horizontally
        var width = Number(dimensions[1]); 
        var height = Number(dimensions[0]);
        var maxWidth = $('#customizer-image').width();
        var newHeight = 0;
        var ratio = 0;    
        var heightLimit = $(window).height() / 2;
        
        // Calculate ratio and new image height
        ratio = maxWidth/height;
        newHeight = ratio * width;
        if (width >= height) {
            ratio = maxWidth/width;
            newHeight = ratio * height;
        }
        
        $('#customizer-image svg').css('height', newHeight + 'px');        
    }
    
    function downloadImage() {        
        // Get SVG markup
        var svgImage = $('#customizer-image svg');
        
        // Preserve height value
        var svgImageCSSHeight = svgImage.css('height');
        
        // Add temporary attributes to workaround Firefox issue
        // @link https://stackoverflow.com/a/42529397/282434
        svgImage.attr('width', svgImage.width() * 2);
        svgImage.attr('height', svgImage.height() * 2);
        
        // Temporarily remove any height styles added for during resizing
        // to workaround Safari image generation issues
        svgImage.css('height', '');
        
        // Create canvas element, set dimensions
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        canvas.width = svgImage.width() * 2;
        canvas.height = svgImage.height() * 2;
        
        // Get SVG data, create URL object
        var svgXML = (new XMLSerializer()).serializeToString($('#customizer-image svg').get(0)); 
        var svgData = 'data:image/svg+xml;base64,' + btoa(svgXML);
        
        var img = new Image();
        img.onload = function() {
            // Draw SVG image to canvas
            context.drawImage(img, 0, 0);
            
            // Get PNG data, change mime type for download
            var imgURI = canvas.toDataURL('image/jpeg', 1);
            
            // Create anchor tag and trigger click to download
            var a = document.createElement('a');
            a.style.display = "none";
            a.setAttribute('download', createSlug(data.product.name) + '.jpg');
            a.setAttribute('href', imgURI);
            a.setAttribute('target', '_blank');

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            
            // Remove temporary attributes
            svgImage.removeAttr('width height');
            svgImage.css('height', svgImageCSSHeight);
        };
        img.src = svgData;
    }
    
    function convertSwatches() {
        var properties = {};        
        var swatches = ko.toJS(viewModel.swatches());
        
        swatches.forEach(function(element, index) {
            if (element.customColor.length > 0) {
                // Using filter instead of find for IE11 compatibility
                var swatchColor = data.colors.filter(function(colorItem) {
                    element.customColor == colorItem.color;
                })[0];
            
                properties[element.label] = swatchColor.label;
            }
        });
        
        return properties;
    }
    
    // Add to cart
    // https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
    // https://shopify.dev/docs/themes/liquid/reference/objects/line_item#line_item-properties
    function addToCart() {
        $('.product-form-customizer').find('[data-product-select]').val(getVariantId(viewModel.currentSize()));
        
        var swatches = ko.toJS(viewModel.swatches());        
        swatches.forEach(function(element, index) {
            //console.log(element, index);
        
            if (element.customColor.length > 0) {
                // Using filter instead of find for IE11 compatibility
                var swatchColor = data.colors.filter(function(colorItem) {
                    return element.customColor == colorItem.color;
                })[0];
                
                //console.log(swatchColor);
                
                if (swatchColor) {
                    $('<input>').attr({
                        'type': 'text',
                        'name': 'properties[' + element.label + ']',
                        'value': swatchColor.label
                    }).appendTo('.product-form-customizer');
                }
            }
        });
        
        //console.log('Add to cart', $('.product-form-customizer').serialize());
        
        var fd = new FormData($('.product-form-customizer').get(0));
        
        // Get SVG markup
        var svgImage = $('#customizer-image svg');
        
        // Preserve height value
        var svgImageCSSHeight = svgImage.css('height');
        
        // Add temporary attributes to workaround Firefox issue
        // @link https://stackoverflow.com/a/42529397/282434
        svgImage.attr('width', svgImage.width() * 2);
        svgImage.attr('height', svgImage.height() * 2);
        
        // Temporarily remove any height styles added for during resizing
        // to workaround Safari image generation issues
        svgImage.css('height', '');        
        
        // Create canvas element, set dimensions
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        canvas.width = svgImage.width() * 2;
        canvas.height = svgImage.height() * 2;       
        
        // Get SVG data, create URL object
        var svgXML = (new XMLSerializer()).serializeToString($('#customizer-image svg').get(0));  
        var svgData = 'data:image/svg+xml;base64,' + btoa(svgXML);            
        
        var img = new Image();
        img.onload = function() {
            context.drawImage(img, 0, 0);
            canvas.toBlob(function(blob) {
                // Attach image to form
                fd.append('properties[Preview]', blob, 'Preview.png');
                //console.log('Appended image', blob);
                
                //console.log('addToCart', fd);
                //console.log('Cart', Sugra.Cart);
            
                if (typeof Sugra.Cart == 'object') {
                    Sugra.Cart.addToCartCustom(fd).then(function() {
                        Sugra.Cart.getCart().then(function(data) {
                            Sugra.Cart.updateCart(data);                    
                            Sugra.Cart.showPanel();                            
                            hideCustomizer();
                            resetCustomizer();
                        });
                    });
                }
                
                // Remove temporary attributes
                svgImage.removeAttr('width height');
                svgImage.css('height', svgImageCSSHeight);               
            });
        };
        img.src = svgData;
    }
    
    // Standalone Shopify.formatMoney
    // @see https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
    function formatMoney(cents, format) {
        if (typeof cents == 'string') {
            cents = cents.replace('.','');
        }
        
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || '${{ amount }}');

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal   = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) { return 0; }

            number = (number/100.0).toFixed(precision);

            var parts   = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents   = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch(formatString.match(placeholderRegex)[1]) {
            case 'amount':
              value = formatWithDelimiters(cents, 2);
              break;
            case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
            case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
              break;
            case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
        }

        return formatString.replace(placeholderRegex, value);
    }
    
    // Create slug from string
    // @see https://gist.github.com/codeguy/6684588
    function createSlug(str) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap � for n, etc
        var from = "������������������������/_,:;";
        var to   = "aaaaaeeeeiiiioooouuuunc------";

        for (var i=0, l=from.length ; i<l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str.replace(/[^a-z0-9 -]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');

        return str;
    }  

	return {
		init: function() {
			initCustomizer();
		}
	};

})(jQuery);
	
this.Sugra = this.Sugra || {};
this.Sugra.Filters = (function($) {

    var filterActiveLink;
    var filterTimeout;
    var filterWait = 1;
    var filterTimeout;
    var filterWait = 100;
    var filterKeyboard = false;
    
    function initFilters() {
        initFilterPanel();
        initFilterCategories();
    }
    
    function initFilterPanel() {
		$('.filter-link').on('click', function(e) {		
			e.preventDefault();
			
            if (Sugra.Util.isMouseEvent(e.originalEvent)) {
                filterKeyboard = false;
            } else {
                filterKeyboard = true;
            }			
            			
            filterPanelShow(this);
		});
		
		$('.filter-panel').on('transitionend MSTransitionEnd webkitTransitionEnd oTransitionEnd', function() {
	        if ( ! $('body').hasClass('filter-panel-open')) {
	            $('.filter-panel').addClass('hidden');
	        }
	    });
		
		$('.filter-panel-close').on('click', function(e) {
			e.preventDefault();
			
			filterPanelHide(this);	
		});
		
        $('.filter-panel').on('keydown', function(e) {
            var ESC_BUTTON = 27;
        
            if (e.which == ESC_BUTTON) {
                filterPanelHide(this);
            }
        });
        
        $('.filter-panel').on('focusin', function() {
            //console.log('Filter panel focusin', filterKeyboard);
            if (filterKeyboard) {
                clearTimeout(filterTimeout);
            }
        });
        
        $('.filter-panel').on('focusout', function() {
            //console.log('Filter panel focusout', filterKeyboard);
            if (filterKeyboard) {
                filterTimeout = setTimeout(function() {
                    filterPanelHide(this);
                }, filterWait);
	        }
        });    
    }
    
	function filterPanelClick(event) {	   	    
	    var targetFilterLink = $(event.target).closest('.filter-link');
	    var targetFilterPanel = $(event.target).closest('.filter-panel');
	    
	    //console.log('filterPanelClick', ! targetFilterLink.length && ! targetFilterPanel.length);
	    
	    // Close nav panel if click target wasn't inside nav link or panel
        if (  ! targetFilterLink.length && ! targetFilterPanel.length) {
            filterPanelHide();
        }
	}    
    
	function filterPanelShow(target, mouse) {
	    //console.log('filterPanelShow');
	    
		$('.filter-panel').removeClass('hidden')
		    .attr('aria-hidden', 'false');    
	    
	    
	    window.setTimeout(function() {
            $('body').addClass('filter-panel-open');
        }, 1);
		
		$('.filter-link').attr('aria-expanded', 'true');
		
		$('.filter-panel .filter-panel-close').focus();
		
		$(document).on('click', filterPanelClick);
	}
	
	function filterPanelHide(target) {
	    //console.log('filterPanelHide');
	    
	    $('body').removeClass('filter-panel-open');
		
		$('.filter-link').attr('aria-expanded', 'false')
		    .focus();
		
		$('.filter-panel').attr('aria-hidden', 'true');
		
		$(document).off('click', filterPanelClick);
	}  
	
	function initFilterCategories() {
	    $('.filter-category button').on('click', function(e) {
	        e.preventDefault();
	        
	        $($(this).data('target')).slideToggle(400);
	    });
	}

	return {
		init: function() {
			initFilters();
		}
	};

})(jQuery);
	
this.Sugra = this.Sugra || {};
this.Sugra.Header = (function($) {

    var navTimeout;
    var navWait = 100;
    var navKeyboard = false;

	function initHeader() {
		initMobileNav();
		initSubnav();
		//initResize();
		//initSticky();
		initSearch();
		initMessagingBanner();
	}
	
	function initMobileNav() {
		$('.nav-link a').on('click', function(e) {		
			e.preventDefault();
            
            if (Sugra.Util.isMouseEvent(e.originalEvent)) {
                navKeyboard = false;
            } else {
                navKeyboard = true;
            }
            			
            navPanelShow(this);
		});
		
		$('.nav-panel').on('transitionend MSTransitionEnd webkitTransitionEnd oTransitionEnd', function() {
	        if ( ! $('body').hasClass('nav-panel-open')) {
	            $('.nav-panel').addClass('hidden');
	        }
	    });
		
		$('.nav-panel-close').on('click', function(e) {
			e.preventDefault();
			navPanelHide(this);	
		});
		
        $('.nav-panel').on('keydown', function(e) {
            var ESC_BUTTON = 27;
        
            if (e.which == ESC_BUTTON) {
                navPanelHide(this);
            }
        });
        
        $('.nav-panel').on('focusin', function() {
            //console.log('Nav panel focusin', navKeyboard);
            if (navKeyboard) {
                clearTimeout(navTimeout);
            }
        });
        
        $('.nav-panel').on('focusout', function() {
            //console.log('Nav panel focusout', navKeyboard);
            if (navKeyboard) {
                navTimeout = setTimeout(function() {
                    navPanelHide(this);
                }, navWait);
	        }
        });
	}
	
	function navPanelClick(event) {	    
	    var targetNavLink = $(event.target).closest('.nav-link');
	    var targetNavPanel = $(event.target).closest('.nav-panel');
	    
	    //console.log('navPanelClick', ! targetNavLink.length && ! targetNavPanel.length);
	    
	    // Close nav panel if click target wasn't inside nav link or panel
        if (  ! targetNavLink.length && ! targetNavPanel.length) {
            navPanelHide();
        }
	}
	
	function navPanelShow(target, mouse) {
	    //console.log('navPanelShow');
	    
		$('.nav-panel').removeClass('hidden')
		    .attr('aria-hidden', 'false');    
	    
	    
	    window.setTimeout(function() {
            $('body').addClass('nav-panel-open');
        }, 1);
		
		$('.nav-link a').attr('aria-expanded', 'true');
		
		$('.nav-panel .nav-panel-close').focus();
		
		$(document).on('click', navPanelClick);
	}
	
	function navPanelHide(target) {
	    //console.log('navPanelHide');
	    
	    $('body').removeClass('nav-panel-open');
		
		$('.nav-link a').attr('aria-expanded', 'false')
		    .focus();
		
		$('.nav-panel').attr('aria-hidden', 'true');
		
		$(document).off('click', navPanelClick);
	}
	
	function initSubnav() {
	    $('.nav-panel-primary .has-subnav').on('click', function(e) {
	        e.preventDefault();
	        
	        $($(this).data('target')).slideToggle(400);
	    });
	}
	
	function initResize() {	
		// Window resize function to toggle aria-hidden true/false
		// for primary-nav and nav-link on target breakpoint
		$(window).on('resize', jQuery.debounce(100, false, function() {			
			if (window.matchMedia('(min-width: 992px)').matches) {
				$('.header .logo').attr('aria-hidden', 'false');
				$('.header .logo-mobile').attr('aria-hidden', 'true');
				$('.primary-nav').attr('aria-hidden', 'false');				
				//$('.nav-link').attr('aria-hidden', 'true');
				return false;
			}
			
			$('.header .logo').attr('aria-hidden', 'true');
			$('.header .logo-mobile').attr('aria-hidden', 'false');
			$('.primary-nav').attr('aria-hidden', 'true');
			//$('.nav-link').attr('aria-hidden', 'false');
		}));
		
		$(window).trigger('resize');
	}	
	
	function initSticky() {
        var headerPos = $('.header').offset();
        $(window).scroll(function() {
            var scrollPos = $(window).scrollTop();
            //console.log(scrollPos, headerPos);

            if (scrollPos > 0) {
                $('.header').addClass('sticky');
            } else {
                $('.header').removeClass('sticky');
            }
        }).trigger('scroll');
	}
	
	function initMessagingBanner() {
	    if ( ! Cookies.get('messaging-banner')) {
	        if ($('.messaging-banner').length > 0) {
	           $('.messaging-banner').addClass('active');
	        }
	    }
	
	    $('.messaging-banner-close').on('click', function(e) {
	        e.preventDefault();
	        
	        $('.messaging-banner').remove();
	        Cookies.set('messaging-banner', true, {expires: 30});
	    });
	}
	
	function initSearch() {	
	    $('.search-link a').on('click', function(e) {
	        e.preventDefault();
	        
	        showSearch();
	    });

        $('.search-panel-close').on('click', function(e) {
            e.preventDefault();
	        
	        hideSearch();
	    });
	    
        $('.search-panel').on('keydown', function(e) {
            var ESC_BUTTON = 27;
        
            if (e.which == ESC_BUTTON) {
                hideSearch();
            }
        });	    
	    
	    $('.search-panel').on('transitionend MSTransitionEnd webkitTransitionEnd oTransitionEnd', function() {
	        if ( ! $('search-panel').attr('aria-hidden') == 'true') {
	            $('search-panel').addClass('hidden');
	        }
	    });	    
	}
	
	function showSearch() {
	    $('.search-link a').attr('aria-expanded', 'true');
	        
        $('.search-panel').removeClass('hidden')
            .attr('aria-hidden', 'false')
            .find('input[type=text]')
            .focus();
            
        window.setTimeout(function() {
            $('.search-panel').addClass('active');
        }, 1);
	}
	
	function hideSearch() {
	    $('.search-link a').attr('aria-expanded', 'false')
            .focus();
        
        $('.search-panel').removeClass('active')
            .attr('aria-hidden', 'true');
	}

	return {
		init: function() {
			initHeader();
		}
	};

})(jQuery);
	
this.Sugra = this.Sugra || {};
this.Sugra.Help = (function($) {

	function initHelp() {
		if ($('.help').length > 0) {
			initSections();
		}
	}
	
	function initSections() {
	    var totalItems = $('.help-section').length;
	
	    $('.help-section-button').on('click', function (e) {
	        e.preventDefault();
	        
	        if ($(this).attr('aria-expanded') == 'false') {
	            showSection(this);
	            
	            return false;
	        }
	        
	        hideSection(this);
	    });
	    
	    $('.help-section-button').on('keydown', function(e) {
            var UP_ARROW = 38;
            var DOWN_ARROW = 40;
            
            switch (e.which) {
                case UP_ARROW:
                    e.preventDefault();
                    
                    var currentItem = $(this).closest('.help-section');
                    var currentIndex = currentItem.index();
                    var nextIndex = currentIndex - 1;
                    
                    if (nextIndex >= 0) {
                        var nextItem = $('.help-section').eq(nextIndex);                    
                        setActiveButton(nextItem.find('button'));
                        
                        return false;
                    }
                    
                    var nextItem = $('.help-section').eq(totalItems - 1);                    
                    setActiveButton(nextItem.find('button'));
                    
                    break;
                case DOWN_ARROW:
                    e.preventDefault();
                    
                    var currentItem = $(this).closest('.help-section');
                    var currentIndex = currentItem.index();
                    var nextIndex = currentIndex + 1;
                    
                    if (nextIndex <= (totalItems - 1)) {
                        var nextItem = $('.help-section').eq(nextIndex);                    
                        setActiveButton(nextItem.find('button'));
                        
                        return false;
                    }
                    
                    var nextItem = $('.help-section').eq(0);                    
                    setActiveButton(nextItem.find('button'));
                    
                    break;
                default:
                    //console.log(e.which);
            }
		});
	    
	    $('.help-content table').wrap('<div class="table"></div>');
	}
	
	function setActiveButton(button) {
	    $('.help-section-button').blur();
	    
	    button.focus();
	}
	
	function showSection(element) {
	    $(element).attr('aria-expanded', 'true');
	
	    var container = $(element).closest('.help-section');	        
	    container.addClass('expanded');
	    
	    var section = $('#' + $(element).attr('aria-controls'));
	    section.attr('tabindex', 0);
	}
	
	function hideSection(element) {
	    $(element).attr('aria-expanded', 'false');
	
	    var container = $(element).closest('.help-section');	        
	    container.removeClass('expanded');
	    
	    var section = $('#' + $(element).attr('aria-controls'));
	    section.attr('tabindex', -1);
	}	

	return {
		init: function() {
			initHelp();
		}
	};

})(jQuery);
	
this.Sugra = this.Sugra || {};
this.Sugra.Home = (function($) {

	function initHome() {
		if ($('.home').length > 0) {
			initHero();
			initFeatures();
		}
	}
	
	function initHero() {}
	
	function initFeatures() {
	    fitty('.home-feature h2');
	}

	return {
		init: function() {
			initHome();
		}
	};

})(jQuery);
	
this.Sugra = this.Sugra || {};
this.Sugra.Newsletter = (function($) {

    var cookieName = 'cold-picnic-newsletter';

	function initNewsletter() {
		initForm();
		initFormValidation();
		initPopUp();
	}
	
	function initForm() {		
		$('.newsletter-popup-close').on('click', function(e) {
			e.preventDefault();
			
			hidePopUp();
		});
		
		$('.newsletter-popup').on('keydown', function(e) {
            var ESC_BUTTON = 27;
        
            if (e.which == ESC_BUTTON) {
                e.preventDefault();
                
                hidePopUp();
            }
        });
	}
	
	function initPopUp() {
		var cookie = readCookie(cookieName);
		
		if (cookie == null) {
			$(window).on('scroll', showPopUp);
		}		
	}
	
	function showPopUp() {	
		var visible = false;
	
		// Open newsletter banner after scrolling 60px down page
		if (visible === false && $(window).scrollTop() >= 60) {				
			visible = true;
			
			// Disable scroll event
			$(window).off('scroll', showPopUp);
			
			$('.newsletter-popup').addClass('active');			
			toggleAccessibilityFocus(true);
			
			$('#newsletter-popup-email').focus();
		}
	}
	
	function hidePopUp() {
	    $('.newsletter-popup').removeClass('active');
        toggleAccessibilityFocus(false);
 
        setDismissCookie();
	}
	
	function setDismissCookie() {
		createCookie(cookieName, '1', 30);
	}
	
	function setSubscribeCookie() {
		createCookie(cookieName, '1', 365);
	}
	
	function toggleAccessibilityFocus(focus) {
		if ( ! focus) {
			$('.newsletter-popup').attr('aria-hidden', 'true');
						
			$('.newsletter-popup').find('input[type=email], button, a')
			    .attr('tabindex', -1);
			
			return false;
		}
		
		$('.newsletter-popup').attr('aria-hidden', 'false');
					
		$('.newsletter-popup').find('input[type=email], button, a')
		    .attr('tabindex', 0);
	}
	
	/*
	 * MailChimp Embedded Forms
	 */
	
    function initFormValidation() {
		// Newsletter form
		// Modified from http://s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js
		
		$(".mc-embedded-subscribe-form").each(function() {
		    //console.log('initFormValidation', this);
		
		    var $this = $(this);
		    $(this).validate({
                errorClass: "mce_inline_error", 
                errorElement: "div", 
                onkeyup: false,
                onfocusout: function(element) { 
                    if ( ! isTooEarly(element)) {
                        $(element).valid();
                    }
                },
                onblur: function(element) { 
                    if ( ! isTooEarly(element)) {
                        $(element).valid();
                    }
                },
                groups: {},
                errorPlacement: function(error, element) {
                    // Place inline error HTML just before the div.mc-field-group closing tag 
                    element.closest('.mc-field-group').append(error);
                },
                submitHandler: function(form) {
                    var data = $(form).serialize();
                    $.ajax({
                        type: 'POST',
                        url: getAjaxSubmitUrl(form),
                        data: data,
                        dataType: 'json',
                        success: function(data) {
                            //console.log(data);
                                            
                            mce_success_cb(data, $this);
                            
                            setDismissCookie();
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            //console.log(textStatus, errorThrown);
                        }
                    });
                }
            });
		});
	}
 	
 	function mce_success_cb(resp, form) {
		$(form).find('.mce-success-response').hide();
		$(form).find('.mce-error-response').hide();

		// On successful form submission, display a success message and reset the form
		if (resp.result == "success") {
			$(form).find('.mce-'+resp.result+'-response').show();
			$(form).find('.mce-'+resp.result+'-response').html(resp.msg);
			$('.mc-embedded-subscribe-form').each(function(){
				this.reset();
			});

		// If the form has errors, display them, inline if possible, or appended to #mce-error-response
		} else {
			if (resp.msg === "captcha") {
				var url = $(form).attr("action");
				var parameters = $.param(resp.params);
				url = url.split("?")[0];
				url += "?";
				url += parameters;
				window.open(url);
			};
			// Example errors - Note: You only get one back at a time even if you submit several that are bad. 
			// Error structure - number indicates the index of the merge field that was invalid, then details
			// Object {result: "error", msg: "6 - Please enter the date"} 
			// Object {result: "error", msg: "4 - Please enter a value"} 
			// Object {result: "error", msg: "9 - Please enter a complete address"} 

			// Try to parse the error into a field index and a message.
			// On failure, just put the dump thing into in the msg variable.
			var index = -1;
			var msg;
			try {
				var parts = resp.msg.split(' - ', 2);
				if (parts[1] == undefined) {
					msg = resp.msg;
				} else {
					i = parseInt(parts[0]);
					if (i.toString() == parts[0]){
						index = parts[0];
						msg = parts[1];
					} else {
						index = -1;
						msg = resp.msg;
					}
				}
			} catch(e) {
				index = -1;
				msg = resp.msg;
			}
			
			// KLUDGE: Handle bad MailChimp captcha message
			if (msg == 'captcha') {
			    msg = 'Please confirm your subscription in the new window.';
			}

			try {
				// If index is -1 if means we don't have data on specifically which field was invalid.
				// Just lump the error message into the generic response div.
				if (index == -1) {
					$(form).find('.mce-' + resp.result + '-response').show();
					$(form).find('.mce-' + resp.result + '-response').html(msg);      
				} else {
					var fieldName = $(form).find("input[name*='" + fnames[index] + "']").attr('name'); // Make sure this exists (they haven't deleted the fnames array lookup)
					var data = {};
					data[fieldName] = msg;
					mc.mce_validator.showErrors(data);
				}
			} catch(e){
				$(form).find('.mce-' + resp.result + '-response').show();
				$(form).find('.mce-' + resp.result + '-response').html(msg);
			}
		}
	}
 	
 	function isTooEarly(element) {
		var fields = $('input:not(:hidden)' , $(element).closest(".mc-field-group"));
		return ($(fields).eq(-1).attr('id') != $(element).attr('id'));
	}
 	
 	function getAjaxSubmitUrl(form) {
		var url = $(form).attr('action');
		url = url.replace('/post?u=', '/post-json?u=');
		url += '&c=?';
		
		return url;
	}	
	
    /*
     * Cookies
     * @link https://www.quirksmode.org/js/cookies.html
     */
    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            var expires = '; expires=' + date.toGMTString();
        } else {
            var expires = '';
        }
        
        document.cookie = name + '=' + value + expires + '; path=/';
    }

    function readCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        
        return null;
    }

    function eraseCookie(name) {
        createCookie(name, '', -1);
    }     

	return {
		init: function() {
			initNewsletter();
		}
	};

})(jQuery);
this.Sugra = this.Sugra || {};
this.Sugra.Newsletter = (function($) {

    var cookieName = 'cold-picnic-newsletter';

	function initNewsletter() {
		initForm();
		//initFormValidation();
		initPopUp();
		//initResize();
	}
	
	function initForm() {
	    $('.newsletter-popup-close').on('click', function(e) {
			e.preventDefault();
			
			$('.newsletter-popup').removeClass('active');
			setDismissCookie();
		});
		
		// Set cookie on subscribe confirmation
		if ($('.newsletter-popup, .footer-newsletter').find('.form-message-success').length > 1) {
		    setSubscribeCookie();
		}
	}
	
	function initFormValidation() {}
	
	function initPopUp() {
		var cookie = Cookies.get(cookieName);
		
		if (typeof cookie === 'undefined') {
			$(window).on('scroll', showPopUp);
		}		
	}
	
	function showPopUp() {
		var visible = false;
	
		// Open newsletter banner after scrolling 60px down page
		if (visible === false && $(window).scrollTop() >= 60) {				
			visible = true;
			
			// Disable scroll event
			$(window).off('scroll', showPopUp);
			
			$('.newsletter-popup').addClass('active');
			toggleAccessibilityFocus(true);
		}
	}
	
	function setDismissCookie() {
		Cookies.set(cookieName, '1', {expires: 30});
	}
	
	function setSubscribeCookie() {
		Cookies.set(cookieName, '1', {expires: 365});
	}	
	
	function toggleAccessibilityFocus(focus) {
		if ( ! focus) {
			$('.newsletter-popup').attr('aria-hidden', 'true');			
			$('.newsletter-popup').find('form, input[type=email], button, a').attr('tabindex', -1);
			
			return false;
		}
		
		$('.newsletter-popup').attr('aria-hidden', 'false');			
		$('.newsletter-popup').find('form, input[type=email], button, a').attr('tabindex', 0);
	}
	
	function initResize() {	
		// Window resize function to toggle aria-hidden true/false
		// for newsletter-popup on target breakpoint
		$(window).on('resize', jQuery.debounce(100, false, function() {			
			if (window.matchMedia('(min-width: 992px)').matches) {
				toggleAccessibilityFocus(false);
				return false;
			}
			
			toggleAccessibilityFocus(true);
		}));
		
		$(window).trigger('resize');
	}

	return {
		init: function() {
			initNewsletter();
		}
	};

})(jQuery);
this.Sugra = this.Sugra || {};
this.Sugra.Newsletter = (function($) {

    var cookieName = 'cold-picnic-newsletter';

	function initNewsletter() {
		initForm();
		initPopUp();
	}
	
	function initForm() {		
		$('.newsletter-form').on('submit', function(e) {
			e.preventDefault();
		
			submitForm(this);
		})
	}
	
	function submitForm(form) {		
		var formData = new FormData(form);
       	
       	resetFormResponse(form);        
        $(form).find('input[type=submit]')
       		.prop('disabled', true);
        
        fetch(form.action, {
            body: formData,
            method: 'POST',
        })
        .then(function(data) {
			if ('status' in data && data.status === 200) {
				$(form).find('input[type=email]')
					.val('');
				
				$(form).find('.form-responses .response-success')
					.text('Thank you for subscribing');
				
				$(form).find('.form-responses')
					.addClass('active');

				setSubscribeCookie();
			}
		})
		.catch(function(error) {
			$(form).find('.form-responses .response-error')
				.text(error);
				
			$(form).find('.form-responses')
				.addClass('active');
		})
		.finally(function() {
			$(form).find('input[type=submit]')
				.prop('disabled', false);
		});
	}
	
	function resetFormResponse(form) {
		$(form).find('.form-responses')
			.removeClass('active');
		
		$(form).find('.form-responses .response')
			.text('');		
	}
	
	function initPopUp() {
		var cookie = readCookie(cookieName);
		
		if (cookie == null) {
			$(window).on('scroll', showPopUp);
		}
		
		$('.newsletter-popup-close').on('click', function(e) {
			e.preventDefault();
			
			hidePopUp();
		});
		
		$('.newsletter-popup').on('keydown', function(e) {
            var ESC_BUTTON = 27;
        
            if (e.which == ESC_BUTTON) {
                e.preventDefault();
                
                hidePopUp();
            }
        });		
	}
	
	function showPopUp() {	
		var visible = false;
	
		// Open newsletter banner after scrolling 60px down page
		if (visible === false && $(window).scrollTop() >= 60) {				
			visible = true;
			
			// Disable scroll event
			$(window).off('scroll', showPopUp);
			
			$('.newsletter-popup').addClass('active');			
			toggleAccessibilityFocus(true);
			
			$('#newsletter-popup-email').focus();
		}
	}
	
	function hidePopUp() {
	    $('.newsletter-popup').removeClass('active');
        toggleAccessibilityFocus(false);
 
        setDismissCookie();
	}
	
	function setDismissCookie() {
		createCookie(cookieName, '1', 30);
	}
	
	function setSubscribeCookie() {
		createCookie(cookieName, '1', 365);
	}
	
	function toggleAccessibilityFocus(focus) {
		if ( ! focus) {
			$('.newsletter-popup').attr('aria-hidden', 'true');
						
			$('.newsletter-popup').find('input[type=email], button, a')
			    .attr('tabindex', -1);
			
			return false;
		}
		
		$('.newsletter-popup').attr('aria-hidden', 'false');
					
		$('.newsletter-popup').find('input[type=email], button, a')
		    .attr('tabindex', 0);
	}	
	
    /*
     * Cookies
     * @link https://www.quirksmode.org/js/cookies.html
     */
    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            var expires = '; expires=' + date.toGMTString();
        } else {
            var expires = '';
        }
        
        document.cookie = name + '=' + value + expires + '; path=/';
    }

    function readCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        
        return null;
    }

    function eraseCookie(name) {
        createCookie(name, '', -1);
    }     

	return {
		init: function() {
			initNewsletter();
		}
	};

})(jQuery);
this.Sugra = this.Sugra || {};
this.Sugra.Product = (function($) {
    
    var formSelector = 'form[action^="/cart/add"]';
    var moneyFormat = '${{ amount }}';
    var productJson;
    
	function initProduct() {	
	    initData();	
	    initAccordion();
		initGallery();
		//initOptions();
		//initSizeOptions();
		initPriceUnit();
		initTabs();
		initOverlay();
	}
	
	function initData() {
	    if ($('[data-product-json').length > 0) {
            productJson = JSON.parse($('[data-product-json]').html());
            //console.log(productJson);
        }
	}
	
	function initAccordion() {
		var totalItems = $('.accordion-item').length;
	
	    // Basic accordion
        // @link http://uniondesign.ca/simple-accordion-without-jquery-ui/
        $(document).on('click', '.accordion-item-label button', function(e) {		
            e.stopPropagation();
            e.preventDefault();

            var activeLabel = $(this);
            setActiveLabel(activeLabel);
            setActivePanel($(this).attr('aria-controls'));
        
            return false;
        });
		
		$('.accordion-item-label button').on('keydown', function(e) {
            var UP_ARROW = 38;
            var DOWN_ARROW = 40;
            
            switch (e.which) {
                case UP_ARROW:
                    e.preventDefault();
                    
                    var currentItem = $(this).closest('.accordion-item');
                    var currentIndex = currentItem.index();
                    var nextIndex = currentIndex - 1;
                    
                    if (nextIndex >= 0) {
                        var nextItem = $('.accordion-item').eq(nextIndex);                    
                        setActiveLabel(nextItem.find('button'));
                        
                        return false;
                    }
                    
                    var nextItem = $('.accordion-item').eq(totalItems - 1);                    
                    setActiveLabel(nextItem.find('button'));
                    
                    break;
                case DOWN_ARROW:
                    e.preventDefault();
                    
                    var currentItem = $(this).closest('.accordion-item');
                    var currentIndex = currentItem.index();
                    var nextIndex = currentIndex + 1;
                    
                    if (nextIndex <= (totalItems - 1)) {
                        var nextItem = $('.accordion-item').eq(nextIndex);                    
                        setActiveLabel(nextItem.find('button'));
                        
                        return false;
                    }
                    
                    var nextItem = $('.accordion-item').eq(0);                    
                    setActiveLabel(nextItem.find('button'));
                    
                    break;
                default:
                    //console.log(e.which);
            }
		});
	}
	
	function setActiveLabel(activeLabel) {
	    //console.log('setActiveLabel', activeLabel);
	
	    activeLabel.addClass('active')
            .attr('aria-expanded', 'true')
            .attr('tabindex', '0')
            .focus();

        $('.accordion-item-label button').not(function(index, element) {				
            if ( ! $(this).is(activeLabel)) {					
                var inactiveLabel = $(this);
                inactiveLabel.removeClass('active')
                    .attr('aria-expanded', 'false')
                    .blur();
            }
        });
	}
	
	function setActivePanel(panelId) {	    
	    //console.log('setActivePanel', panelId);
	
	    var activePanel = $('#' + panelId);	    

        activePanel.attr('aria-hidden', 'false')
            .attr('tabindex', '0')
            .slideDown('fast');
				
        $('.accordion-item-content').not(activePanel)
            .attr('aria-hidden', 'true')
            .attr('tabindex', '-1')
            .hide();
	}
	
	function initGallery() {			
		if ($('.product-gallery').length > 0) {
			var slickSettings = {
				arrows: false,
				dots: true,
				infinite: true,
				mobileFirst: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: 0,
				responsive: [
					{
						breakpoint: 1023,
						settings: 'unslick'
					}
				]
			};
		
			$('.product-gallery').slick(slickSettings);
			
			$(window).on('resize', function() {
				//console.log('Window resize');
				if ($(window).width() < 1024 && ! $('.product-gallery').hasClass('slick-initialized')) {
					$('.product-gallery').slick(slickSettings);
				}
			});
		}
	}
	
	function initOptions() {
		// Size select
		$(document).on('click', '.option-block a', function(e) {
		    e.preventDefault();
		
			//console.log('click', '.option-block a');
			var $this = $(this);
			var parent = $this.parent().parent();
			var target = parent.data('target');
			var value = String($this.data('value'))
			    .replace(/"/g, '\\"')
			    .replace(/'/g, "\\'")
			    .replace('/', '\\/');
			//console.log($this.data('value'), value);

			$(target).val($this.data('value'));
			$(target).find('[value="' + value + '"]').prop('selected', true).trigger('change');
			//console.log(target, $(target).val());

			parent.find('.option-block a').removeClass('active');
			$this.addClass('active');
		});
	}

	function initSizeOptions() {
		console.log('initSizeOptions');

		$('.product-option-size .option-blocks').remove();

		var sizeOptions = '<ul class="option-blocks" data-target="{target}">{options}</ul>';
		var sizeOptionBlock = '<li class="option-block"><a href="#" data-value="{value}">{label}</a></li>';
		var sizeOptionBlocks = '';
		var sizeOptionsDisplay = 'normal';
		var sizeSelectId = 'select#' + $('.product-option-size select').attr('id');
		var sizeSelected = $('.product-option-size select').val();

		$('.product-option-size option').each(function() {
			if ($(this).val() !== '') {
				//sizeOptions.push({value: $(this).val(), label: $(this).text()});
				var block = sizeOptionBlock;
				var value = String($(this).val()).replace(/"/g, '&quot;');
				
				block = block.replace('{value}', value);
				block = block.replace('{label}', $(this).text());
				sizeOptionBlocks += block;
			}

			if ($(this).text().length > 4) {
				sizeOptionsDisplay = 'wide';
			}
		});
		
		//console.log(sizeOptionBlocks);

		if (sizeOptionBlocks.length > 0) {
			sizeOptions = sizeOptions.replace('{target}', sizeSelectId);
			sizeOptions = sizeOptions.replace('{options}', sizeOptionBlocks);

			$('.product-option-size label').after(sizeOptions);
		}
		
		$('.product-option-size .option-block').each(function() {
			//console.log($(this).find('a').data('value'), sizeSelected);
			if ($(this).find('a').data('value') == sizeSelected) {
				$(this).find('a').addClass('active');
			}
		});
	}
	
	function initPriceUnit() {
	    if ($('[data-price-unit]').length > 0) {
	        var form = $(formSelector);
	        var price = $('[data-price-wrapper]');
	        var priceUnit = Number(price.data('price-unit')) / 100;
	        var priceDisplay = $('[data-product-price]');	        
	        var variablePrice = false;
	        var variablePriceOption;
	        var minimumLength = Number($('.product-quantity').data('minimum'));
	        
	        if ($('.product-option-minimum-length').length > 0) {
	            //console.log('Minimum length');
                var optionIndex, optionNumber;
                                
                if (productJson) {                
                    var optionIndex = productJson.options.findIndex(function(option) {
                        return option == 'Minimum Length';
                    });
                    
                    if (optionIndex !== -1) {                
                        variablePriceOption = optionIndex + 1;
                        //console.log('Minimum Length', variablePriceOption);
                        
                        variablePrice = true;
                    }
                }
            }
	        
	        $('input[name=quantity]').on('change keyup', function() {
	            var newQuantity = Number($(this).val());
	            var newPrice;
	            var newMinimumLength;
	            
	            // Invalid quantity
	            if (newQuantity < minimumLength) {
	                form.find('[type="submit"]').prop('disabled', true);
	                $(this).addClass('error');
	                
	                return false;
	            }	            
	            
	            //console.log(variablePrice);
	            if (variablePrice) {
	                // Get new minimum length and unit price
	                productJson.variants.forEach(function(variant) {
	                    var optionKey = 'option' + variablePriceOption;
	                    if (variant[optionKey]) {	
	                        //console.log(newQuantity, Number(variant[optionKey]), variant.price);
	                        if (newQuantity >= Number(variant[optionKey])) {
	                            newMinimumLength = variant[optionKey];
	                            newPrice = variant.price;	                            
	                        }
	                    }
	                });
	                
	                // Update price display and minimum length option
	                if (newPrice) {                  
	                    //console.log('New price', newPrice);
	                    //console.log('New minimum length', newMinimumLength);
	                    
                        price.data('price-unit', newPrice);
                        priceUnit = Number(price.data('price-unit')) / 100;
                        $('.price-unit').text(formatMoney(newPrice, moneyFormat) + ' per yard');
                        
                        $('.product-option-minimum-length select').val(newMinimumLength)
                            .trigger('change');
                    }
	            }
	            
	            // Update price display
	            if (newQuantity >= minimumLength) {
	                var newPriceCents = (newQuantity * priceUnit) * 100;
	                var newPriceDisplay = formatMoney(newPriceCents, moneyFormat);
	                //console.log(newPriceCents, newPriceDisplay);
	                
	                form.find('[type="submit"]').prop('disabled', false);
	                $(this).removeClass('error');
	                priceDisplay.text(newPriceDisplay)
	            }
	        }).trigger('change');
	    }
	}
	
    function initTabs() {
        var totalTabs = $('.product-recommended-tabs li').length;
    
        $('.product-recommended-tabs button').on('click', function(e) {
            e.preventDefault();
        
			var activeTab = $('#' + $(this).data('tab'));
			var activeLink = $(this);
			
			setActiveTab(activeLink);
			setActiveTabPanel(activeTab);
		});
		
		var firstTab = $('.product-recommended-tabs button').first();
		
		firstTab.addClass('active')
            .attr('aria-selected', 'true')
            .attr('aria-expanded', 'true')
            .attr('tabindex', '0');
            
        $('#' + firstTab.data('tab')).attr('aria-hidden', 'false')
            .attr('tabindex', '0')
            .show();
		    
		$('.product-recommended-tabs button').on('keydown', function(e) {
		    var LEFT_ARROW = 37;
            var RIGHT_ARROW = 39;
            var DOWN_ARROW = 40;
            
            switch (e.which) {
                case LEFT_ARROW:
                    e.preventDefault();
                
                    var currentIndex = $(this).closest('li').index();
                    var nextIndex = currentIndex - 1;
                    var nextTab = $('.product-recommended-tabs li').eq(nextIndex)
                        .find('button');
                
                    if (nextIndex >= 0) {
                        setActiveTab(nextTab);
                        setActiveTabPanel('#' + nextTab.attr('aria-controls'));
                        return false;
                    }
                    
                    nextTab = $('.product-recommended-tabs li').eq(totalTabs - 1)
                        .find('button');
                
                    setActiveTab(nextTab);
                    setActiveTabPanel('#' + nextTab.attr('aria-controls'));
                    break;
                case RIGHT_ARROW:
                    e.preventDefault();
                
                    var currentIndex = $(this).closest('li').index();
                    var nextIndex = currentIndex + 1;
                    var nextTab = $('.product-recommended-tabs li').eq(nextIndex)
                        .find('button');
                
                    if (nextIndex <= (totalTabs - 1)) {
                        setActiveTab(nextTab);
                        setActiveTabPanel('#' + nextTab.attr('aria-controls'));
                        return false;
                    }
                    
                    nextTab = $('.product-recommended-tabs li').eq(0)
                        .find('button');
                
                    setActiveTab(nextTab);
                    setActiveTabPanel('#' + nextTab.attr('aria-controls'));
                    break;
                case DOWN_ARROW:
                    e.preventDefault();
                
                    setActiveTab($(this));
                    setActiveTabPanel('#' + $(this).attr('aria-controls'));
                    break;
                default:
                    //console.log(e.which);
            }
		});
    }
    
	function setActiveTab(activeTab) {	
	    //console.log(activeTab);
	    
	    activeTab.addClass('active')
            .attr('aria-selected', 'true')
            .attr('aria-expanded', 'true')
            .attr('tabindex', '0')
            .focus();

        $('.product-recommended-tabs button').not(function(index, element) {				
            if ( ! $(this).is(activeTab)) {					
                var inactiveTab = $(this);
                inactiveTab.removeClass('active')
                    .attr('aria-selected', 'false')
                    .attr('aria-expanded', 'false')
                    .attr('tabindex', '-1')
                    .blur();
            }
        });
	}
	
	function setActiveTabPanel(panelId) {
        //console.log(panelId);
	
	    var activeTabPanel = $(panelId);	    

        activeTabPanel.attr('aria-hidden', 'false')
            .attr('tabindex', '0')
            .show();
				
        $('.product-recommended-tab').not(activeTabPanel)
            .attr('aria-hidden', 'true')
            .attr('tabindex', '-1')
            .hide();				
	}    
    
    function initOverlay() {
        $('.product-gallery-image').on('click', function(e) {
            var index = $(this).index();
        
            e.preventDefault();
            overlayShow(index);
        });
        
        $('.product-overlay-close').on('click', function(e) {
            e.preventDefault();
            overlayHide();
        });
    }
    
	function overlayClick(event) {	    
	    var targetOverlayImages = $(event.target);
	    
	    // Close overlay if click wasn't inside images container
        if ($(event.target).hasClass('product-overlay')) {
            overlayHide();
        }
	}    
    
    function overlayShow(index) {
	    //console.log('overlayShow');
	    
	    $('body').addClass('product-overlay-open');
		$('.product-overlay').attr('aria-hidden', 'false');
		$(document).on('click', overlayClick);
		
		// Scroll 
        var overlayImage = $('.overlay-image').get(index);
        var overlayImagePosition = $(overlayImage).position();
        
        if (overlayImagePosition.top > 0) {
            $('.product-overlay').scrollTop(overlayImagePosition.top);		
        }
	}
	
	function overlayHide() {
	    //console.log('overlayHide');
	    
	    $('body').removeClass('product-overlay-open');
		$('.product-overlay').attr('aria-hidden', 'true');
		$(document).off('click', overlayClick);
	}
	
	// Standalone Shopify.formatMoney
    // @see https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
    formatMoney = function(cents, format) {
        if (typeof cents == 'string') {
            cents = cents.replace('.','');
        }
        
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || '${{ amount }}');

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal   = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) { return 0; }

            number = (number/100.0).toFixed(precision);

            var parts   = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents   = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch(formatString.match(placeholderRegex)[1]) {
            case 'amount':
              value = formatWithDelimiters(cents, 2);
              break;
            case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
            case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
              break;
            case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
        }

        return formatString.replace(placeholderRegex, value);
    }; 

	return {
		init: function() {
			initProduct();
		}
	};

})(jQuery);
this.Sugra = this.Sugra || {};
this.Sugra.Shop = (function($) {

	function initShop() {
		if ($('.shop-features').length > 0) {
			initFeatures();
		}
	}
	
	function initFeatures() {
	    fitty('.shop-feature h2');
	}

	return {
		init: function() {
			initShop();
		}
	};

})(jQuery);
	
$(document).ready(function() {
    // Init sections
    var sections = new slate.Sections();
    sections.register('product', theme.Product);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function(evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Add class for cookies support
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

    // Global utility functions
    Sugra.Util = {};
    Sugra.Util.isMouseEvent = function(event) {
        //console.log('isMouseEvent event', event);
        
        mouse = false;
        if (event.detail == 1) {
            mouse = true;
        }

        //console.log('isMouseEvent mouse', mouse); 
        
        return mouse;   
    };
  
    // Remove preload class to enable transitions
    // https://css-tricks.com/transitions-only-after-page-load/
    $('body').removeClass('preload');

    // Init theme modules
    // See /scripts/modules
    var modules = [
        'About',
        'Cart',
        'Collections',
        'Filters',
        'Header',
        'Help',
        'Home',      
        'Newsletter',      
        'Product',
        'Shop',
        'Customizer'
    ];

    for (var index in modules) {
        //console.log('Sugra.' + modules[index] + ' init');

        Sugra[modules[index]].init();
    }
});
